<div class="tableWrapper">
  <table aria-label="Site users table" class="settingsTable">
    <thead class="settingsTable__head">
      <tr class="settingsTable__row settingsTable__row--header">
        <th>
          <pp-checkbox
            [ppChecked]="isAllSelected"
            ppSize="medium"
            class="checkbox"
            ppType="solid"
            (ppOnValueChange)="selectAllShares()"
          ></pp-checkbox>
        </th>
        <th scope="col" class="settingsTable__header settingsTable__username-row">
          {{ 'username_and_email' | ppTranslate }}
        </th>

        <th scope="col" class="hide--mobile settingsTable__header settingsTable__loginDate">
          {{ 'last_login_date' | ppTranslate }}
        </th>

        <th scope="col" class="hide--mobile settingsTable__header settingsTable__access">
          {{ 'access' | ppTranslate }}
        </th>

        <th scope="col" class="hide--mobile settingsTable__header settingsTable__tags-header">
          <span class="settingsTable__header--tags"> {{ 'accessible_tags' | ppTranslate }} </span>
        </th>

        <th scope="col" class="settingsTable__content-right settingsTable__header">
          {{ 'actions' | ppTranslate }}
        </th>
      </tr>
    </thead>

    <tbody class="settingsTable__body">
      @for (share of sortedFilteredShares; track share) {
        <tr class="settingsTable__row">
          <td>
            <pp-site-settings-users-select-cell
              [ppShareId]="share.shareId"
              [ppDisabled]="share.shareOption === EUserRole.ACCOUNT_ADMIN"
            ></pp-site-settings-users-select-cell>
          </td>
          <td class="settingsTable__basic-info settingsTable__cell">
            <div class="settingsTable__user">
              @if (users[share.userId]?.avatarPublicUrl) {
                <img
                  ppTooltip
                  ppImage
                  class="settingsTable__avatar"
                  [src]="users[share.userId].avatarPublicUrl"
                  [ppTitle]="users[share.userId].userName"
                  />
              }
              @if (!users[share.userId]?.avatarPublicUrl) {
                <img
                  class="settingsTable__avatar"
                  [src]="EIconPath.PLACEHOLDER_USER"
                  />
              }
              <div class="settingsTable__multirow">
                <p class="settingsTable__multirow-top">
                  <span
                    [innerHTML]="users[share.userId]?.userName || '' | highlightKeyword: ppKeyword"
                  ></span>
                </p>
                <p class="settingsTable__multirow-bottom">
                  <span
                    [innerHTML]="users[share.userId]?.email | highlightKeyword: ppKeyword"
                  ></span>
                </p>
              </div>
            </div>
          </td>
          <td class="hide--mobile settingsTable__cell settingsTable__loginDate">
            <div class="settingsTable__loginDate--text">
              @if (
                users[share.userId]?.lastActivityEpochMillis && users[share.userId]?.verified
                ) {
                {{ users[share.userId]?.lastActivityEpochMillis | ppDate }}
              }
              @if (
                !users[share.userId]?.lastActivityEpochMillis && users[share.userId]?.verified
                ) {
                {{ 'N/A' | ppTranslate }}
              }
            </div>
          </td>
          <td class="hide--mobile settingsTable__cell settingsTable__shareOption">
            <div class="settingsTable__shareOption--text">
              <span
                [innerHTML]="shareOptionLabels[share.shareOption] | highlightKeyword: ppKeyword"
              ></span>
            </div>
          </td>
          <td class="hide--mobile settingsTable__cell settingsTable__tags">
            @if (share.tagLimited && share.defectTags.length > 0) {
              <span>
                @for (tag of share.defectTags; track tag) {
                  <span class="sw-tag-sm">
                    <span [innerHTML]="tag | highlightKeyword: ppKeyword"></span>
                  </span>
                }
              </span>
            }
            @if (
              share.tagLimited &&
              share.defectTags.length === 0 &&
              share.shareOption !== EUserRole.SITE_ADMIN
              ) {
              <span
                class="settingsTable__tagInfo"
                >
                <span [innerHTML]="'None' | highlightKeyword: ppKeyword"></span>
              </span>
            }
            @if (!share.tagLimited || share.shareOption === EUserRole.SITE_ADMIN) {
              <span
                class="settingsTable__tagInfo"
                >
                <span [innerHTML]="'All' | highlightKeyword: ppKeyword"></span>
              </span>
            }
          </td>
          <td
            class="settingsTable__content-right settingsTable__cell"
            [ngClass]="
              users[share.userId]?.verified ? '' : 'settingsTable__content-right--expanded'
            "
            >
            <div class="settingsTable__content-right--buttons">
              @if (!users[share.userId]?.verified) {
                <pp-button
                  ppTooltip
                  ppTitle="Resend Invitation"
                  ppStyle="secondary"
                  id="resendInviteButton"
                  ppId="resendInvitationBtn-{{ share.shareId }}"
                  (ppAction)="resendInvitation(share)"
                  ppSize="small"
                  >
                  <pp-icon
                    [ppSrc]="EIconPath.ICON_MISC_MAIL_18"
                    ppColor="grey-500"
                    ppClass="setHeight17"
                  ></pp-icon>
                </pp-button>
              }
              <pp-edit-button
                (ppAction)="editShare(share)"
                ppTooltip
                [ppTitle]="
                  share.shareOption === EUserRole.ACCOUNT_ADMIN
                    ? ('cant_edit_account_admin_permission' | ppTranslate)
                    : ''
                "
                [ppDisabled]="share.shareOption === EUserRole.ACCOUNT_ADMIN"
                ppSize="small"
                ppId="editUserBtn-{{ share.shareId }}"
                [class.cursor--disabled]="share.shareOption === EUserRole.ACCOUNT_ADMIN"
              ></pp-edit-button>
              <pp-delete-share-button
                ppTooltip
                [ppTitle]="
                  share.shareOption === EUserRole.ACCOUNT_ADMIN
                    ? ('cant_edit_account_admin_permission' | ppTranslate)
                    : ''
                "
                [ppShare]="share"
                [ppDisabled]="share.shareOption === EUserRole.ACCOUNT_ADMIN"
              ></pp-delete-share-button>
            </div>
          </td>
        </tr>
      }

      @if (workspaceShares.data.length <= 1) {
        <div class="settingsSection__no-content">
          {{ 'no_users_found' | ppTranslate }}
        </div>
      }
    </tbody>
  </table>
</div>
